import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    IconButton,
    Tooltip
} from '@material-ui/core';
import { CheckIcon, CopyIcon, TimesIcon } from '../../../../icons';
import { useNotify } from '../../../../hooks/useNotify';

import SortableTableCell from '../../../../components/atom/SortableTableCell';
import { buildWidgetScript } from '../../../../utils/widgetScript';

const AvailabilityCell = ({ availability }) => {
    if (availability?.available) {
        return (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                <CheckIcon style={{ color: 'green' }} />
            </div>
        );
    }

    const reasons = availability?.reasons || [];

    return (
        <Tooltip
            title={
                <div>
                    {reasons.map((reason, i) => (
                        <div key={i}>{reason}</div>
                    ))}
                </div>
            }
            arrow
        >
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                <TimesIcon style={{ color: 'red' }} />
            </span>
        </Tooltip>
    );
};

const ClientActivitiesTable = ({
    activities,
    setSorting,
    sortDir,
    sort,
    handleItemClick,
    isClientView,
    clientKey
}) => {
    const { notifySuccess } = useNotify();

    const handleCopyWidget = (e, activityId) => {
        e.stopPropagation();
        navigator.clipboard.writeText(buildWidgetScript(activityId, clientKey));
        notifySuccess('Widget script copied to clipboard');
    };

    return (
        <Grid item container xs={12} justifyContent="center">
            <Table style={{ backgroundColor: 'white' }} size="small">
                <TableHead>
                    <TableRow>
                        <SortableTableCell
                            arrow={sort === 'name' ? sortDir : ''}
                            onClick={() => setSorting('name')}
                        >
                            Name
                        </SortableTableCell>
                        <SortableTableCell
                            arrow={sort === 'islands.name' ? sortDir : ''}
                            onClick={() => setSorting('islands.name')}
                        >
                            Island
                        </SortableTableCell>
                        {isClientView ? (
                            <TableCell align="center">Available</TableCell>
                        ) : (
                            <>
                                <SortableTableCell
                                    arrow={sort === 'is_available' ? sortDir : ''}
                                    onClick={() => setSorting('is_available')}
                                    align="center"
                                >
                                    Available
                                </SortableTableCell>
                                <SortableTableCell
                                    arrow={sort === 'is_visible' ? sortDir : ''}
                                    onClick={() => setSorting('is_visible')}
                                    align="center"
                                >
                                    Standalone
                                </SortableTableCell>
                            </>
                        )}
                        <SortableTableCell
                            arrow={sort === 'companies.name' ? sortDir : ''}
                            onClick={() => setSorting('companies.name')}
                        >
                            Vendor
                        </SortableTableCell>
                        <SortableTableCell
                            arrow={sort === 'vendor_sku' ? sortDir : ''}
                            onClick={() => setSorting('vendor_sku')}
                        >
                            Vendor SKU
                        </SortableTableCell>
                        <TableCell>ID</TableCell>
                        {clientKey && <TableCell />}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {activities &&
                        activities.map(activity => (
                            <TableRow
                                key={activity.id}
                                hover
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleItemClick(activity.id)}
                            >
                                <TableCell>{activity.name}</TableCell>
                                <TableCell>{activity.island?.name || '-'}</TableCell>
                                {isClientView ? (
                                    <TableCell align="center">
                                        <AvailabilityCell availability={activity.availability} />
                                    </TableCell>
                                ) : (
                                    <>
                                        <TableCell align="center">
                                            <div
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {activity.is_available ? (
                                                    <CheckIcon />
                                                ) : (
                                                    <TimesIcon />
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {activity.is_visible ? (
                                                    <CheckIcon />
                                                ) : (
                                                    <TimesIcon />
                                                )}
                                            </div>
                                        </TableCell>
                                    </>
                                )}
                                <TableCell>{activity.company?.name || '-'}</TableCell>
                                <TableCell>{activity.vendor_sku}</TableCell>
                                <TableCell>{activity.id}</TableCell>
                                {clientKey && (
                                    <TableCell padding="none">
                                        <Tooltip title="Copy widget script">
                                            <IconButton
                                                size="small"
                                                onClick={e => handleCopyWidget(e, activity.id)}
                                            >
                                                <CopyIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </Grid>
    );
};

export default ClientActivitiesTable;
